import { OwnerEnv } from './env';

export const getCdnImageUrl = (url: string) => {
  return `${OwnerEnv.assetsUrl}${url}`;
};
